import { useStore } from 'vuex';
const store = useStore();

export default class Helper {
  async ChangeMode(Currentview) {
    // console.log('xxxx');
    await store
      .dispatch('ChangeMode', {
        Currentview,
      })
      .then(() => {
        return 'success';
      });
  }
  async ChangeViewMode(CurrentViewMode) {
    //console.log('yyyy');
    await store
      .dispatch('ChangeViewMode', {
        CurrentViewMode,
      })
      .then(() => {
        return 'success';
      });
  }
}
